// extracted by mini-css-extract-plugin
module.exports = {"select":"css_select__2QQo8","select__menu-item__text":"css_select__menu-item__text__1_iau"};